const REQUIRED_ENV_VARS = [
  "REACT_APP_API_URL",
  "REACT_APP_REST_API_URL",
  "REACT_APP_SOCKET_URL",
  "REACT_APP_URL",
  "REACT_APP_AWS_BASE_URL",
];

export const validateEnv = () => {
  const missing = REQUIRED_ENV_VARS.filter((name) => !process.env[name]);
  if (missing.length) {
    console.error("Missing required environment variable(s):", missing.join(", "));
  }
};
